import { render, staticRenderFns } from "./EFaturaEkliDosya.vue?vue&type=template&id=19b7d2ca&scoped=true"
import script from "./EFaturaEkliDosya.vue?vue&type=script&lang=js"
export * from "./EFaturaEkliDosya.vue?vue&type=script&lang=js"
import style0 from "./EFaturaEkliDosya.vue?vue&type=style&index=0&id=19b7d2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7d2ca",
  null
  
)

export default component.exports